module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "notifications",
      "tag": "div"
    }
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('notification', {
      key: item.id,
      staticClass: "notification-item",
      attrs: {
        "index": index,
        "type": item.type,
        "message": item.message,
        "container": '.notifications',
        "direction": 'right',
        "duration": item.duration,
        "id": item.id
      },
      on: {
        "closed-by-user": function($event) {
          return _vm.destroyNotification(item)
        },
        "closed-automatically": function($event) {
          return _vm.destroyNotification(item)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd5d109"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Notifications.vue
// module id = 143
// module chunks = 14